<template>
  <div class="rte">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.rte {
  font-size: 1.125rem;
  line-height: 1.8;

  .intro {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.6;
  }

  section {
    margin-top: 40px;

    &:first-child {
      margin-top: 0;
    }
  }
}

.rte h1,
.rte h2,
.rte h3,
.rte h4,
.rte h5,
.rte h6 {
  margin-top: 40px;
  margin-bottom: 15px;
}

.rte h1,
.rte h2,
.rte h3 {
  margin-bottom: 20px;
}

.rte h1:first-child,
.rte h2:first-child,
.rte h3:first-child,
.rte h4:first-child,
.rte h5:first-child,
.rte h6:first-child {
  margin-top: 20px;
}

.rte a:not(.btn):not(.v-button) {
  font-weight: 500;
  text-decoration: underline;
}

.rte strong a:not(.btn):not(.v-button) {
  font-weight: inherit;
}

.rte p,
.rte ul,
.rte ol {
  margin-bottom: 20px;
  margin-top: 15px;
}

.rte ul,
.rte ol {
  margin-left: 0;
  padding-left: 24px;

  ul,
  ol {
    margin: 0;
  }
}

.rte img {
  border: 1px solid var(--g-color-gray-200);
  margin-bottom: 15px;
  margin-top: 15px;
  max-width: 100%;
  height: auto !important;

  &[style='float:right;'] {
    margin-bottom: 15px;
    margin-left: 15px;
  }
}

.rte blockquote {
  font-size: 1.4em;
  margin: 30px auto;
  font-style: italic;
  color: #444;
  padding: 1em 30px 1em 75px;
  border-left: 6px solid var(--g-color-primary);
  line-height: 1.6;
  position: relative;
  background: var(--g-color-gray-100);

  &::before {
    font-family: Arial;
    content: '\201C';
    color: var(--g-color-primary);
    font-size: 4em;
    position: absolute;
    left: 10px;
    top: -10px;
  }
}

.rte iframe {
  margin-top: 10px;
  max-width: 100%;
}

.rte hr {
  border: none;
  border-top: 1px solid #ccc;
  margin-bottom: 40px;
  margin-top: 40px;
}
</style>
